import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPinIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 17,
	viewBox: "0 0 15 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M5.17232 8.21829L2.10965 3.99099L9.66367 1.35686L9.89362 6.57195C11.2696 6.97468 13.5495 7.94476 13.0774 8.10939L3.63487 11.402C2.87948 11.6654 4.34509 9.38929 5.17232 8.21829Z",
			stroke: "#0080E2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8.53488,
			y: 11.0116,
			width: .48881,
			height: 3.86344,
			transform: "rotate(-19.2239 8.53488 11.0116)",
			fill: "#39414D",
			stroke: "#0080E2",
			strokeWidth: .48881
		})
	]
});
const ForwardRef = forwardRef(SvgPinIcon);
export { ForwardRef as ReactComponent };
